import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors as memberSelectors } from 'member-reducer'
import { StripePaymentStep } from 'member-portal/components'
import { MembershipType } from 'types'
import { makeMembershipIdPath, PATH, PAYMENT_STEP_TYPE } from 'config'

const propTypes = {
  membership: MembershipType.isRequired,
}

function GoldUpgradePayment({ membership }) {
  const { sfid: membershipId } = membership
  const nextStep = makeMembershipIdPath(
    membershipId,
    PATH.UPGRADES,
    PATH.MEMBERSHIP,
    PATH.CONFIRM_AND_LOGIN,
  )

  return (
    <StripePaymentStep
      membership={membership}
      paymentStepType={PAYMENT_STEP_TYPE.MEMBERSHIP_UPGRADE}
      nextStep={nextStep}
      showTermsAndConditions
    />
  )
}

GoldUpgradePayment.propTypes = propTypes

function mapStateToProps(state) {
  return {
    membership: memberSelectors.membership(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  GoldUpgradePayment,
)
